/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/ban-types */
import * as Table from "~/components/Table";

const BASE_STYLE = { minWidth: "25px" };

export const TRANSACTIONS_TABLE_HEADERS = [
  { name: "Customer", span: 5, style: { ...BASE_STYLE } },
  { name: "Counterparty", span: 5, style: { ...BASE_STYLE } },
  {
    name: "Counterparty person",
    span: 5,
    style: { ...BASE_STYLE, visibility: "collapse" },
  },
  { name: "Category", span: 4, style: { ...BASE_STYLE } },
  {
    name: "Amount",
    span: 3,
    style: { ...BASE_STYLE, minWidth: "80px", textAlign: "right" },
  },
  { name: "Asset", span: 2, style: { ...BASE_STYLE, minWidth: "80px" } },
  { name: "Date", span: 3, style: { ...BASE_STYLE, minWidth: "120px" } },
  {
    name: "Status",
    span: 3,
    style: { ...BASE_STYLE, minWidth: "120px" },
  },
  {
    name: "Details and actions",
    span: 8,
    style: { position: "sticky", right: 0, textIndent: "-99999px", background: "#f8f8f8" },
  },
];

export default function TransactionTable({
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof Table.Container>) {
  return (
    <Table.Container {...props}>
      <Table.Table narrow fullwidth={true}>
        <Table.ColGroup spans={TRANSACTIONS_TABLE_HEADERS.map((h) => h.span)} />
        <Table.THead>
          <Table.THR>
            {TRANSACTIONS_TABLE_HEADERS.map((header) => (
              <Table.TH key={header.name} style={header.style as any}>
                {header.name}
              </Table.TH>
            ))}
          </Table.THR>
        </Table.THead>

        <Table.TBody>{children}</Table.TBody>
      </Table.Table>
    </Table.Container>
  );
}
